import Vue from 'vue';
import firebase from 'firebase/app';
import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

import App from './App.vue';
import router from './router';
import store from './store';

import debounce from './plugins/debounce';
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
import './plugins/toggleBtn';
import formatter from './utils'

import globalMixins from './mixins/globalMixins';
import '@/assets/css/global.scss';
import getLanguage from './utils/getLanguage';
import installTokenLogin from './plugins/tokenLogin';
import { isAdminLoginPage } from './utils/adminLogin';

installTokenLogin(router);

if (!isAdminLoginPage()) {
  Sentry.init({
    Vue,
    dsn: 'https://56b0770ee00a4e53bc5295503eaa8747@o508716.ingest.sentry.io/5601728',
    autoSessionTracking: true,
    integrations: [
      new Integrations.BrowserTracing(),
    ],
    tracesSampleRate: 1.0,
  });
}

Vue.config.productionTip = false;

Vue.mixin(globalMixins);
Vue.filter('currency', (value) => formatter(value, getLanguage(window.location.href) === 'pt-BR' ? 'BRL' : 'EUR'));
// Initialize Firebase
firebase.initializeApp({
  apiKey: 'AIzaSyD5FFOEoK_whftRiymyonaeOM-CG7PfjUo',
  authDomain: 'ondivan-staging.firebaseapp.com',
  databaseURL: 'https://ondivan-staging.firebaseio.com',
  projectId: 'ondivan-staging',
  storageBucket: 'ondivan-staging.appspot.com',
  messagingSenderId: '941218487207',
});

new Vue({
  i18n,
  router,
  vuetify,
  store,
  debounce,
  render: (h) => h(App),
}).$mount('#app');

// let app = '';

// firebase.auth().onAuthStateChanged(() => {
//   if (!app) {
//     app = new Vue({
//       router,
//       render: h => h(App),
//     }).$mount('#app');
//   }
// });
